module.exports = "/out/1762ff7a3df6f7b8cc07940ffd282b68.svg";